import { isManagerCancelledShift } from "./attendanceCoverage";

const number = (value) => value !== null && value !== undefined && value !== "" && Number.isFinite(Number(value));

// Capability, not today's data volume. Old punches remain readable after a
// source is disconnected; synthetic no-show rows alone are not an actual source.
export function hasActualHoursSource(store = {}, rows = []) {
  return Boolean(store.time_entries_enabled || store.pos_provider ||
    store.sales_app_integration_toast || store.omnivore_integration ||
    rows.some(row => row?.result_start !== "no show" &&
      number(row?.shift_start) && number(row?.shift_end)));
}

export function localCoverageShifts(shifts = [], roleTypes) {
  return shifts.filter(shift => shift && !shift.other_store && !isManagerCancelledShift(shift) &&
    (!roleTypes || roleTypes.includes(shift.role_type)));
}

// Event boundaries preserve partial hours and overnight shifts without needing
// a labor-model deployment. Timed unpaid breaks remove coverage; paid breaks do not.
export function buildScheduledCoverage(shifts = [], roleTypes, start = 0, end = 24) {
  const events = new Map([[start, 0], [end, 0]]);
  const add = (time, delta) => events.set(time, (events.get(time) || 0) + delta);
  localCoverageShifts(shifts, roleTypes).forEach(shift => {
    if (!number(shift.shift_start) || !number(shift.shift_end) || (number(shift.hours) && Number(shift.hours) <= 0)) return;
    const from = Number(shift.shift_start), to = Number(shift.shift_end);
    if (to <= from) return;
    const breaks = Array.isArray(shift.unpaid_breaks) && shift.unpaid_breaks.length
      ? shift.unpaid_breaks
      : [{ break_start: shift.break_start, break_length: shift.break_length },
         { break_start: shift.break_start_2, break_length: shift.break_length_2 }];
    const gaps = breaks.filter(b => number(b?.break_start) && number(b.break_length ?? b.break_duration))
      .map(b => [Math.max(from, Number(b.break_start)), Math.min(to, Number(b.break_start) + Number(b.break_length ?? b.break_duration))])
      .filter(([a, b]) => b > a).sort((a, b) => a[0] - b[0]);
    let cursor = from;
    [...gaps, [to, to]].forEach(([a, b]) => {
      if (a > cursor) { add(cursor, 1); add(a, -1); }
      cursor = Math.max(cursor, b);
    });
  });
  let scheduled = 0;
  return [...events].sort((a, b) => a[0] - b[0]).map(([time, delta]) => ({ time, scheduled: scheduled += delta }));
}
